import { tinycolor } from './index';
export * from './index';
export * from './css-color-names';
export * from './readability';
export * from './to-ms-filter';
export * from './from-ratio';
export * from './format-input';
export * from './random';
export * from './interfaces';
export * from './conversion';
// kept for backwards compatability with v1
export default tinycolor;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ctrl/tinycolor/dist/module/public_api.js
// module id = 553
// module chunks = 0